(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-gvx-clean-purchase]').forEach(purchase => {
      if (purchase.dataset.ready) return;
      purchase.dataset.ready = 'true';
      const container = purchase.closest('[data-js-product-container]');
      const variantData = container?.querySelector('[data-selected-variant]');
      const sync = () => {
        let variant;
        try { variant = JSON.parse(variantData?.textContent || 'null'); } catch { return; }
        if (!variant) return;
        container.dataset.gvxVariantAvailable = String(!!variant.available);
        purchase.querySelector('[data-gvx-availability]').hidden = !!variant.available;
      };
      sync();
      if (variantData) new MutationObserver(sync).observe(variantData, {childList: true, subtree: true, characterData: true});
    });
    document.querySelectorAll('[data-gvx-build]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const system = document.querySelector('[data-gvx-product-system]');
      const input = system?.querySelector('[data-gvx-cart-vehicle-key]');
      const sync = () => {
        const key = input?.disabled ? '' : input?.value;
        let shown = 0;
        section.querySelectorAll('[data-gvx-build-keys]').forEach(card => {
          let keys = [];
          try { keys = JSON.parse(card.dataset.gvxBuildKeys); } catch { /* invalid cards stay hidden */ }
          card.hidden = !key || !keys.includes(key) || shown >= 3;
          if (!card.hidden) shown++;
        });
        section.hidden = shown === 0;
      };
      sync();
      document.addEventListener('gvx:vehicle-change', sync);
      if (system) new MutationObserver(sync).observe(system, {attributes:true, attributeFilter:['data-gvx-purchase-state']});
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href^="#GvxProductDetails-"]');
    if (link) document.querySelector(link.getAttribute('href'))?.querySelector('details:nth-child(2)')?.setAttribute('open','');
  });
})();
